<template>
    <v-card-text v-if="item" class="v-main__wrap">
        <v-auto-img v-if="item.imagekey" :src="item.imagekey" max-height="40vh"/>
        <h1 class="my-3">{{item.title}}</h1>
        <div v-safe-html="item.content" class="zoezi-news-content"></div>
        <div v-if="showDate || showAuthor">
            <span v-if="showDate" class="zoezi-date"><v-icon small>mdi-clock-outline</v-icon>{{date}}</span>
            <span v-if="showAuthor && item.author" class="zoezi-author"><v-icon small>mdi-account</v-icon>{{item.author.firstname}} {{item.author.lastname}}</span>
        </div>
        <div class="d-flex mt-2" v-if="hasPostPermission">
            <div class="z-clickable primary--text" @click="editArticle = true">
                {{$translate('Edit the post')}}
            </div>
            <v-spacer />
            <div class="z-clickable error--text" @click="remove(item)">
                {{$translate('Remove the post')}}
            </div>
        </div>
        <news-compose :news-item="item" v-if="editArticle" @close="editArticle = false" />
    </v-card-text>
    <v-container v-else class="text-center" style="top: 50%; padding: 50px;">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-container>
</template>

<script>
import NewsCompose from '../components/NewsCompose.vue'
import {makeMetaDescription} from '../util.js'

export default {
    name: 'zoezi-news-display',
    zoezi: {
        title: 'News post',
        icon: 'mdi-newspaper-variant-outline',
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'key',
                    prop: 'itemKey'
                },
                {
                    id: 'id',
                    prop: 'slug'
                }
            ]
        })
    },
    components: {
        NewsCompose
    },

    props: {
        itemKey: {
            title: 'News item key',
            type: String
        },
        slug: {
            title: 'News item SEO slug',
            type: String
        },
        value: {
            type: Object,
            default: () => null
        },
        showDate: {
            title: 'Show date',
            type: Boolean,
            default: true
        },
        showAuthor: {
            title: 'Show author',
            type: Boolean,
            default: true
        },
    },

    data: () => ({
        item: null,
        editArticle: false
    }),

    computed: {
        date() {
            return this.item?.published ? Date.formatFullShort(this.item.published) : '';
        },
        hasPostPermission() {
            return this.$store.state?.user?.permissions?.find(x => x == 'Mailing handling');
        },
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.item = this.value;
            }
        },
        itemKey: {
            immediate: true,
            handler(key) {
                if (key != null) {
                    let params = Number.isInteger(key) ? {id: key} : {key: key};
                    this.fetchItem(params);
                }
            }
        },
        slug: {
            immediate: true,
            handler(slug) {
                if (slug != null){
                    let params = {slug: slug};
                    this.fetchItem(params);
                }
            }
        },
        item: {
            immediate: true,
            handler(item) {
                if (item?.title) {
                    let siteTitle = this.$root.siteconfig?.root?.props?.title || '';
                    document.title = item.title + (siteTitle ? ' - ' + siteTitle : '');

                    let description = makeMetaDescription(item.content);
                    if (description) {
                        document.getElementById('metadescription')?.setAttribute('content', description);
                    }
                }
            }
        }
    },

    methods: {
        fetchItem(params) {
            this.$api.get('/api/news/item/get', params).then(item => {
                this.item = item;
            }).catch(() => {})
        },
        remove(item) {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove post'),
                text: this.$translate('Are you sure you want to remove the post?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.$api.post('/api/news/item/remove', null, {id: item.id}).then(() => {
                        this.currentArticle = null;
                    })
                }
            });
        },
    },
}
</script>
